import React from 'react';

interface IconProps {
    name: string;
}

const Icon = ({ name, ...rest }: IconProps & React.HTMLAttributes<SVGElement>): React.ReactElement => {

    return (
        <svg {...rest}>
            <use href={`/static/material-icons/svg/${name}.svg#icon`}></use>
        </svg>
    );
};

export default Icon;
